import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ChoiceType from '../ChoiceType';

const SingleChoice2Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ChoiceType choices={question.choices} />
    </>
);

SingleChoice2Type.propTypes = {
    question: PropTypes.object.isRequired,
};


export default SingleChoice2Type;
